import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=0b4eb814&scoped=true"
import script from "./forgot-password.vue?vue&type=script&lang=js"
export * from "./forgot-password.vue?vue&type=script&lang=js"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=0b4eb814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4eb814",
  null
  
)

export default component.exports